import { usePricingModulesState } from '../../context/contexts/PricingModuleContext';
import { Pages, Roles } from '../../context/contexts/UserContext/permissionsTypes';
import { LogicalRoute, LogicalRouteImportProps } from '../helpers/LogicalRoute';
import useHasPermissions from '../../hooks/useHasPermissions';
import IspmPage from '../../modules/ispm/IspmPage';
import { ISPMBlockPage } from '../../modules/ispm/ISPMBlockPage/ISPMBlockPage';
import { LAYOUT_TABS } from '@silverfort-nodelibs/common/utils/consts';

export const IspmRouting = (props: LogicalRouteImportProps) => {
    const { isPageBlocked } = usePricingModulesState();
    const displayBlockPage = isPageBlocked(LAYOUT_TABS.INSIGHTS.ID);
    const disabled = !useHasPermissions({ permission: Pages.INSIGHTS, role: Roles.VIEWER });

    return (
        <LogicalRoute
            {...props}
            component={IspmPage}
            blockPageComponent={ISPMBlockPage}
            displayBlockPage={displayBlockPage}
            disabled={disabled}
        />
    );
};
